import React from 'react';
import SectionOutlet from './SectionOutlet';

const Phase0Layout: React.FC = () => <SectionOutlet section="phase-0" />;

export default Phase0Layout;
